namespace Nobox.Nobox {
    export interface StatistikForm {
        TenantId: Serenity.StringEditor;
        ChannelId: Serenity.IntegerEditor;
        T1B: Serenity.IntegerEditor;
        T1E: Serenity.IntegerEditor;
        T2B: Serenity.IntegerEditor;
        T2E: Serenity.IntegerEditor;
        T3B: Serenity.IntegerEditor;
        T3E: Serenity.IntegerEditor;
        T4B: Serenity.IntegerEditor;
        T4E: Serenity.IntegerEditor;
        T5B: Serenity.IntegerEditor;
        T5E: Serenity.IntegerEditor;
        T6B: Serenity.IntegerEditor;
        T6E: Serenity.IntegerEditor;
        T7B: Serenity.IntegerEditor;
        T7E: Serenity.IntegerEditor;
        T8B: Serenity.IntegerEditor;
        T8E: Serenity.IntegerEditor;
        T9B: Serenity.IntegerEditor;
        T9E: Serenity.IntegerEditor;
        T10B: Serenity.IntegerEditor;
        T10E: Serenity.IntegerEditor;
        T11B: Serenity.IntegerEditor;
        T11E: Serenity.IntegerEditor;
        T12B: Serenity.IntegerEditor;
        T12E: Serenity.IntegerEditor;
        T13B: Serenity.IntegerEditor;
        T13E: Serenity.IntegerEditor;
        T14B: Serenity.IntegerEditor;
        T14E: Serenity.IntegerEditor;
        T15B: Serenity.IntegerEditor;
        T15E: Serenity.IntegerEditor;
        T16B: Serenity.IntegerEditor;
        T16E: Serenity.IntegerEditor;
        T17B: Serenity.IntegerEditor;
        T17E: Serenity.IntegerEditor;
        T18B: Serenity.IntegerEditor;
        T18E: Serenity.IntegerEditor;
        T19B: Serenity.IntegerEditor;
        T19E: Serenity.IntegerEditor;
        T20B: Serenity.IntegerEditor;
        T20E: Serenity.IntegerEditor;
        T21B: Serenity.IntegerEditor;
        T21E: Serenity.IntegerEditor;
        T22B: Serenity.IntegerEditor;
        T22E: Serenity.IntegerEditor;
        T23B: Serenity.IntegerEditor;
        T23E: Serenity.IntegerEditor;
        T24B: Serenity.IntegerEditor;
        T24E: Serenity.IntegerEditor;
        T25B: Serenity.IntegerEditor;
        T25E: Serenity.IntegerEditor;
        T26B: Serenity.IntegerEditor;
        T26E: Serenity.IntegerEditor;
        T27B: Serenity.IntegerEditor;
        T27E: Serenity.IntegerEditor;
        T28B: Serenity.IntegerEditor;
        T28E: Serenity.IntegerEditor;
        T29B: Serenity.IntegerEditor;
        T29E: Serenity.IntegerEditor;
        T30B: Serenity.IntegerEditor;
        T30E: Serenity.IntegerEditor;
        T31B: Serenity.IntegerEditor;
        T31E: Serenity.IntegerEditor;
    }

    export class StatistikForm extends Serenity.PrefixedContext {
        static formKey = 'Nobox.Statistik';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!StatistikForm.init)  {
                StatistikForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;

                Q.initFormType(StatistikForm, [
                    'TenantId', w0,
                    'ChannelId', w1,
                    'T1B', w1,
                    'T1E', w1,
                    'T2B', w1,
                    'T2E', w1,
                    'T3B', w1,
                    'T3E', w1,
                    'T4B', w1,
                    'T4E', w1,
                    'T5B', w1,
                    'T5E', w1,
                    'T6B', w1,
                    'T6E', w1,
                    'T7B', w1,
                    'T7E', w1,
                    'T8B', w1,
                    'T8E', w1,
                    'T9B', w1,
                    'T9E', w1,
                    'T10B', w1,
                    'T10E', w1,
                    'T11B', w1,
                    'T11E', w1,
                    'T12B', w1,
                    'T12E', w1,
                    'T13B', w1,
                    'T13E', w1,
                    'T14B', w1,
                    'T14E', w1,
                    'T15B', w1,
                    'T15E', w1,
                    'T16B', w1,
                    'T16E', w1,
                    'T17B', w1,
                    'T17E', w1,
                    'T18B', w1,
                    'T18E', w1,
                    'T19B', w1,
                    'T19E', w1,
                    'T20B', w1,
                    'T20E', w1,
                    'T21B', w1,
                    'T21E', w1,
                    'T22B', w1,
                    'T22E', w1,
                    'T23B', w1,
                    'T23E', w1,
                    'T24B', w1,
                    'T24E', w1,
                    'T25B', w1,
                    'T25E', w1,
                    'T26B', w1,
                    'T26E', w1,
                    'T27B', w1,
                    'T27E', w1,
                    'T28B', w1,
                    'T28E', w1,
                    'T29B', w1,
                    'T29E', w1,
                    'T30B', w1,
                    'T30E', w1,
                    'T31B', w1,
                    'T31E', w1
                ]);
            }
        }
    }
}
